import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hourlyWage: "1000",
  hoursPerWeek: "52",
  offDaysPerWeek: "2",
  annualSalary: null
};

const salarySlice = createSlice({
  name: 'salaryCalculator',
  initialState,
  reducers: {
    setHourlyWage: (state, action) => {
      state.hourlyWage = action.payload;
    },
    setHoursPerWeek: (state, action) => {
      state.hoursPerWeek = action.payload;
    },
    setOffDaysPerWeek: (state, action) => {
      state.offDaysPerWeek = action.payload;
    },
    setAnnualSalary: (state, action) => {
      state.annualSalary = action.payload;
    },
    setTotalHours:(state, action) => {
      state.totalWorkingHours = action.payload
    },
      resetSalaryData: (state) => {
          return initialState;
        },
  }
});

export const {
  setHourlyWage,
  setHoursPerWeek,
  setOffDaysPerWeek,
  setAnnualSalary,
  setTotalHours,resetSalaryData
} = salarySlice.actions;

export default salarySlice.reducer;